import React from 'react'
import { useSelector } from 'react-redux'
import { Loader } from 'semantic-ui-react'
import styles from './content-loader.module.css'

const ContentLoader = () => {
  const loadingData = useSelector((store) => store.loader.loadingData)

  return loadingData ? (
    <div className={styles.loaderContainer}>
      <Loader inverted active={loadingData} size="massive" />
    </div>
  ) : null
}

export default ContentLoader
